import * as Sentry from '@sentry/react';

export const captureException = (flow: string, error: unknown): void => {
  Sentry.withScope((scope) => {
    scope.setTag('area', 'payment_link');
    scope.setTag('flow', flow);

    const message =
      error instanceof Error ? error.message : 'Unknown error';

    Sentry.captureException(new Error(message));
  });
};
